import React, { PropsWithChildren, useEffect, useRef } from 'react'

// Fancybox
import { Fancybox as NativeFancybox } from '@fancyapps/ui'
import '@fancyapps/ui/dist/fancybox/fancybox.css'

import type { OptionsType } from '@fancyapps/ui/types/Fancybox/options'

type FancyboxProps = {
  delegate?: string
  options?: Partial<OptionsType>
}

const Fancybox = (props: PropsWithChildren<FancyboxProps>) => {
  const containerRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    const container = containerRef.current

    NativeFancybox.bind(container, props.delegate || '[data-fancybox]', props.options || {})

    return () => {
      NativeFancybox.unbind(container)
      NativeFancybox.close()
    }
  }, [])

  return <div ref={containerRef}>{props.children}</div>
}

export default Fancybox
